/**
 * ATL scripts used on the main website (by logged-out users) only 
 */

$(document).ready(function () {

	/* HOME PAGE */

	// time for each slider on front page slider
	$('#front-page-slider').banner({
		transition: 7000
	});

	// home page blog
	$('.social-feed-container').mouseenter(function (e) {
		var post = this,
			title = post.getElementsByClassName("post-title")[0];

		title.style.textDecoration = "underline";

		$(post).mouseleave(function (e) {
			title.style.textDecoration = "none";
		});
	});

	$('.staff-list li').hover(function () {
		var uid = $(this).parent().attr('id');
		var index = $(this).index() + 1;
		$('li:not(:nth-child(' + index + '))', $(this).parent()).addClass('transparent');
		$('.staff-list:not(#' + uid + ') li').addClass('transparent');
	}, function () {
		$('.staff-list li').removeClass('transparent');
	});

	$('.testimonial .read-more a, .testimonial .read-less a').click(function (e) {
		e.preventDefault();
		$(this).parent().parent().toggleClass('expanded');
	});

	$('.naati-language-list li span.a:contains("YES")').parent().addClass('white-hilighted');
	$('.naati-language-list li span.a:contains("NO")').parent().addClass('pink-hilighted');


	general_service_resize()
	$(window).resize(function () {
		general_service_resize();

		if ($(window).width() <= 780) {
			$('#site-header .nav').removeAttr('style');
			$('.sub-menu').removeClass('nav-open').removeAttr('style');
		}
	});

	$('.btn-reset').click(function (e) {
		e.preventDefault();
		$('input[type=text], input[type=email], textarea, select', $(this).parents('form')).val('');
		$('input[type=checkbox]', $(this).parents('form')).prop('checked', false);
		var radios = new Array();
		$('input[type=radio]', $(this).parents('form')).each(function () {
			if ($.inArray($(this).attr('name'), radios) == -1) {
				$('input[type=radio][name=' + $(this).attr('name') + ']', $(this).parents('form')).prop("checked", false);
				$('input[type=radio][name=' + $(this).attr('name') + ']', $(this).parents('form')).first().prop("checked", true);
				radios.push($(this).attr('name'));
			}
		});
		
		show_job_type_field($('input[name=job_type]').val());
	});

	// BOOKING FORMS

	$("#additional-email-checkbox").click(function (e) {
		var checkbox = this,
			row = document.getElementById("additional-email-row"),
			emailInput = document.getElementById("additional-email");

		if ($(checkbox).is(":checked")) {
			$(row).show(500);
		}
		else {
			emailInput.value = "";
			$(row).hide(500);
		}
	});
/*
	$('form.booking-form').submit(function (e) {

		if ($('#company').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Name of Company / Individual field.");
			failed_tries_popup();
			return false;
		}

		if ($('#street_address').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Street Address field.");
			failed_tries_popup();
			return false;
		}

		if ($('#state').val() == "" || $('#postcode').val() == "" || $('#suburb').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the City, Suburb and Postcode fields.");
			failed_tries_popup();
			return false;
		}

		if ($('#telephone').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Telephone field");
			failed_tries_popup();
			return false;
		}

		if ($('#email').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Email Address field");
			failed_tries_popup();
			return false;
		}

		if (!isValidEmail($('#email').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Email Address");
			failed_tries_popup();
			return false;
		}

		if ($('#email').val() != $('#confirm-email').val()) {
			failed_tries++;
			e.preventDefault();
			alert("The email and confirmation email addresses do not match");
			failed_tries_popup();
			return false;
		}

		if ($("#additional-email-checkbox").is(":checked") && !isValidEmail($('#additional-email').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Additional Email Address");
			failed_tries_popup();
			return false;
		}

		var errors = false;

		if (!isValidDateTime($('#datetime').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please check the format of the date and time, 'Day dd/mm/yyyy @ HH:ii am|pm' for instance 'Monday 01/12/2013 @ 12:00 am'");
			errors = true;
			failed_tries_popup();
			return false;
		}

		if (!isFutureDate($('#datetime').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please select a future date and time");
			errors = true;
			failed_tries_popup();
			return false;
		}

		if (errors) {
			failed_tries++;
			e.preventDefault();
			failed_tries_popup();
			return false;
		}

		if ($('#duration').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Duration field");
			failed_tries_popup();
			return false;
		}
		else if (!isValidDuration($('#duration').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Duration");
			reset_spinner($(this));
			failed_tries_popup();
			return false;
		}

		var language = document.getElementById('language').value;
		if (language == "" || language == "Select a language" || (language == "Other" && document.getElementById('other-language-name').value == "")) {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Language field");
			failed_tries_popup();
			return false;
		}

		if ($('#client').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Client's Name field");
			failed_tries_popup();
			return false;
		}

		if ($('#job_reference').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Claim No / Job Ref field");
			failed_tries_popup();
			return false;
		}

		if ($('#contact_person').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Contact Person field");
			failed_tries_popup();
			return false;
		}

		if (!$('[name=job_type]:checked').length) {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Job Type field");
			failed_tries_popup();
			return false;
		}

		if ($('[name=job_type]:checked').val() === 'onsite') {
			if ($('#job_location').val() == "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Job Location field");
				failed_tries_popup();
				return false;
			}

		}
		else if ($('[name=job_type]:checked').val() === 'videoconference') {
			if ($('#videoconference-info').val() === "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Videoconference type field");
				failed_tries_popup();
				return false;
			}
		}
		else { // teleconference
			if ($('#job_phone').val() == "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Job Phone Number field");
				failed_tries_popup();
				return false;
			}
		}

		if ($('#invoice_company').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Invoice Address field");
			failed_tries_popup();
			return false;
		}

		if ($('#instructed_by').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Instructed By field");
			failed_tries_popup();
			return false;
		}

		if ($('#contact_phone').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Contact Phone No. field");
			failed_tries_popup();
			return false;
		}

		if ($('#undertaking:checked').length == 0) {
			failed_tries++;
			e.preventDefault();
			alert("Please agree to the terms");
			failed_tries_popup();
			return false;
		}

		function failed_tries_popup() {
			if (failed_tries >= 3 && $('form.booking-form').attr('id') == "book-an-interpreter") {

				e.preventDefault();

				var dialog = $('#atl-duplicate-dialog');
				var failed_input = '<textarea id="failed_input" name="failed_input" placeholder="Enter your booking details here" rows="13" style="width:97.5%"></textarea>';

				$('h4', dialog).text("Any problem in creating new booking ?");
				$('.modal-body', dialog).html("<p>We have detected a few failed submissions of this form.<br />Please use the area below to provide your contact details/your interpreting request and we will get back to you as soon as possible.</p><p><big>Please precise your name, phone number and email address.</big></p><br />" + failed_input + "<br />");
				$('.btn-action', dialog).off();
				$('.btn-action', dialog).attr("href", "#");
				$('.yes', dialog).width("260px");
				$('.yes', dialog).text("Keep on booking manually");
				$('.yes', dialog).on('click', function () {
					dialog.modal('hide');
					return false;
				});

				$('.no', dialog).text("Submit");
				$('.no', dialog).on('click', function () {
					$('#failed_form').val($('#failed_input').val());
					$('#failed_new_booking').submit();
					this.style.display = "none";
					return false;
				});

				dialog.modal('show');
			}
		}

		if ($(this).attr('id') == "book-an-interpreter" && $("[name=edition_confirmed]", this).length == 0) {
			var form = this;
			e.preventDefault();

			var dialog = $('#atl-confirm-dialog');

			$('h4', dialog).text("Submit this booking");

			$('.modal-body', dialog).html("<p>Are you sure you want to submit this booking form ?</p>");
			$('.btn-dark-blue', dialog).off();
			$('.btn-dark-blue', dialog).attr("href", "#");
			$('.btn-dark-blue', dialog).text("Yes");
			$('.btn-dark-blue', dialog).on('click', function () {
				$(this).hide(100, function () {
					this.style.display = "none";
					$(form).append('<input type="hidden" name="edition_confirmed" value="" />');
					$('[name=submit]', form).click();
				});
				return false;
			});

			dialog.modal('show');
		}

		if ($(this).attr('id') == "edit_booking" && $("[name=edition_confirmed]", this).length == 0) {
			var form = this;
			e.preventDefault();

			var dialog = $('#atl-confirm-dialog');

			$('h4', dialog).text("Edit this booking");

			$('.modal-body', dialog).html("<p>Are you sure you want to submit this edition form ?</p>");
			$('.btn-dark-blue', dialog).off();
			$('.btn-dark-blue', dialog).attr("href", "#");
			$('.btn-dark-blue', dialog).text("Yes");
			$('.btn-dark-blue', dialog).on('click', function () {
				$(form).append('<input type="hidden" name="edition_confirmed" value="" />');
				$('[name=submit]', form).click();
				this.style.display = "none";
				return false;
			});

			dialog.modal('show');
		}
	});*/


	$('.job-code-radio').click(function (e) { // display sub job codes when a job code is selected
		var job_code = this.value;
		showSubJobCodes($("input[name=job_type]").val(), job_code);
	});


	$("#only-files-names-1").click(function (e) {
		displayFileInput(1, "names");
	});

	$("#provide-files-1").click(function (e) {
		displayFileInput(1, "files");
	});

	$("#attachments-1").change(function (e) {
		if (this.files.length == 0) {
			document.getElementById("only-files-names-1").style.display = "inline-block";
			document.getElementById("add-other-row").style.display = "none";
		}
		else {
			document.getElementById("only-files-names-1").style.display = "none";
			document.getElementById("add-other-row").style.display = "table-row";
		}
	});

	$("#files-names-1").change(function (e) {
		if (this.value == "") {
			document.getElementById("add-other-row").style.display = "none";
		}
		else {
			document.getElementById("add-other-row").style.display = "table-row";
		}
	});

	function displayFileInput(index, type) {
		var rows1 = document.getElementsByClassName("provide-files-row-" + index),
			rows2 = document.getElementsByClassName("only-files-names-row-" + index),
			i;

		if (type == "names") {
			for (i = 0; i < rows1.length; i++) {
				rows1[i].style.display = "none";
			}
			for (i = 0; i < rows2.length; i++) {
				rows2[i].style.display = "table-row";
			}
		}
		else {
			for (i = 0; i < rows1.length; i++) {
				rows1[i].style.display = "table-row";
			}
			for (i = 0; i < rows2.length; i++) {
				rows2[i].style.display = "none";
			}
		}
	}

	$('.file-language-select').change(function (e) {
		var from = this.id.match(/language-from-(\d*)/),
			to = this.id.match(/language-to-(\d*)/),
			opposite;

		if (from) {
			opposite = document.getElementById("language-to-" + from[1]);
		}
		else if (to) {
			opposite = document.getElementById("language-from-" + to[1]);
		}
		if (this.value != "English") {
			opposite.value = "English";
			opposite.setAttribute("readonly", "");
		}
		else {
			opposite.removeAttribute("readonly");
		}
	});

	$('form.translation-form').submit(function (e) {

		if ($('#company').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Name of Company / Individual field.");
			failed_tries_popup();
			return false;
		}

		if ($('#street_address').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Street Address field.");
			failed_tries_popup();
			return false;
		}

		if ($('#state').val() == "" || $('#postcode').val() == "" || $('#suburb').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the City, Suburb and Postcode fields.");
			failed_tries_popup();
			return false;
		}

		if ($('#telephone').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Telephone field");
			failed_tries_popup();
			return false;
		}

		if ($('#email').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Email Address field");
			failed_tries_popup();
			return false;
		}

		if (!isValidEmail($('#email').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Email Address");
			failed_tries_popup();
			return false;
		}

		if ($('#email').val() != $('#confirm-email').val()) {
			failed_tries++;
			e.preventDefault();
			alert("The email and confirmation email addresses do not match");
			failed_tries_popup();
			return false;
		}

		if ($("#additional-email-checkbox").is(":checked") && !isValidEmail($('#additional-email').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Additional Email Address");
			failed_tries_popup();
			return false;
		}

		var from = document.getElementsByName("language_from[]"),
			to = document.getElementsByName("language_to[]"),
			i;

		for (i = 0; i < from.length; i++) {
			if (from[i].value == "" || from[i].value == "Other" && document.getElementById('language-from-name-' + (i + 1)).value == "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Language From field #" + (i + 1));
				failed_tries_popup();
				return false;
			}
			else if (to[i].value == "" || to[i].value == "Other" && document.getElementById('language-to-name-' + (i + 1)).value == "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Language To field #" + (i + 1));
				failed_tries_popup();
				return false;
			}
			else if (from[i].value != "English" && to[i].value != "English") {
				failed_tries++;
				e.preventDefault();
				alert("At least the Language From or the Language To must be English for file #" + (i + 1));
				failed_tries_popup();
				return false;
			}
		}

		if ($('#client').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Client's Name field");
			failed_tries_popup();
			return false;
		}

		if ($('#job_reference').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Claim No / Job Ref field");
			failed_tries_popup();
			return false;
		}

		if ($('#invoice_company').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Invoice Company field");
			failed_tries_popup();
			return false;
		}

		if ($('#invoice_state').val() == "" || $('#invoice_postcode').val() == "" || $('#invoice_suburb').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Invoice City, Suburb and Postcode fields.");
			failed_tries_popup();
			return false;
		}

		if ($('#instructed_by').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Instructed By field");
			failed_tries_popup();
			return false;
		}

		if ($('#contact_phone').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Contact Phone No. field");
			failed_tries_popup();
			return false;
		}

		if ($('#undertaking:checked').length == 0) {
			failed_tries++;
			e.preventDefault();
			alert("Please agree to the terms");
			failed_tries_popup();
			return false;
		}

		function failed_tries_popup() {
			if (failed_tries >= 3 && $('form.translation-form').attr('id') == "new_translation") {

				e.preventDefault();

				var dialog = $('#atl-duplicate-dialog');
				var failed_input = '';

				$('h3', dialog).text("Any problem in creating new translation request ?");
				$('.modal-body', dialog).html("<p>We have detected a few failed submissions of this form.<br />Please use the area below to provide your contact details/your translating request and we will get back to you as soon as possible.</p><p>You can attach the files to translate now (max 2Mb) or send it to us later.</p><form method='post' action='?atl_action=failed_new_translation' id='failed_new_translation' enctype='multipart/form-data'>" + document.getElementById("failed-new-translation-form").innerHTML + "</form><br />");
				$('.btn-action', dialog).off();
				$('.btn-action', dialog).attr("href", "#");
				$('.yes', dialog).text("Keep on booking manually");
				$('.yes', dialog).on('click', function () {
					dialog.modal('hide');
					return false;
				});

				$('.no', dialog).text("Submit");
				$('.no', dialog).on('click', function () {
					$('#failed_new_translation').submit();
					this.style.display = "none";
					return false;
				});

				dialog.modal('show');
			}
		}

		if ($("[name=edition_confirmed]", this).length == 0) {
			var form = this;
			e.preventDefault();

			var dialog = $('#atl-confirm-dialog');

			$('h4', dialog).text("Submit this translation request");

			$('.modal-body', dialog).html("<p>Are you sure you want to submit this translation request form ?</p><div class='spinner spinner-modal'></div>");
			$('.btn-dark-blue', dialog).off();
			$('.btn-dark-blue', dialog).attr("href", "#");
			$('.btn-dark-blue', dialog).text("Yes");
			$('.btn-dark-blue', dialog).on('click', function () {
				dialog.modal('hide');
				$('.modal-backdrop').show();
				$("#atl-spinner-loading").show(10, function () {
					for (i = 0; i < from.length; i++) {
						from[i].removeAttribute("disabled");
						to[i].removeAttribute("disabled");
					}
					$(form).append('<input type="hidden" name="edition_confirmed" value="" />');
					$('[name=submit]', form).click();
				});
				return false;
			});

			dialog.modal('show');
		}

	});

	$('form#join-our-panel').submit(function (e) {
		if ($('#last_name').val() == "") {
			e.preventDefault();
			alert("Please fill out your last name");
			return false;
		}

		if ($('#first_name').val() == "") {
			e.preventDefault();
			alert("Please fill out your first name");
			return false;
		}

		if ($('#address').val() == "") {
			e.preventDefault();
			alert("Please fill out your address");
			return false;
		}

		if ($('#phone').val() == "") {
			e.preventDefault();
			alert("Please fill out your phone");
			return false;
		}

		if ($('#email').val() == "") {
			e.preventDefault();
			alert("Please fill out your email address");
			return false;
		}

		if (!isValidEmail($('#email').val())) {
			e.preventDefault();
			alert("Please enter a valid Email Address");
			return false;
		}

		if ($('#resume').val() == "") {
			e.preventDefault();
			alert("Please attach your resume");
			return false;
		}

		if ($('#accreditation').val() == "") {
			e.preventDefault();
			alert("Please attach your accreditation");
			return false;
		}
	});

	$('.service-language-list li').each(function () {
		if ($(this).index() % 2 < 1)
			$(this).addClass('even');
	});

	function testimonials_homepage($ele) {
		$ele.fadeIn(1000).delay(5000).fadeOut(1000, function () {
			var $next = $(this).next('.testimonial');
			testimonials_homepage($next.length > 0 ? $next : $(this).parent().children().first());
		});
	}

	testimonials_homepage($("#testimonials-carousel > .testimonial").first());

});
